export const LOGIN_PATH = '/login'
export const DEFAULT_REDIRECT_PATH = '/index'

export function getSafeRedirect(redirect) {
  if (!redirect || typeof redirect !== 'string') return DEFAULT_REDIRECT_PATH
  if (!redirect.startsWith('/') || redirect.startsWith('//')) return DEFAULT_REDIRECT_PATH
  if ([LOGIN_PATH, '/404', '/403'].includes(redirect)) return DEFAULT_REDIRECT_PATH
  return redirect
}

export function getLoginRoute(route) {
  const redirect = route?.fullPath && route.path !== LOGIN_PATH ? route.fullPath : DEFAULT_REDIRECT_PATH
  return { path: LOGIN_PATH, query: { redirect } }
}
